import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { StorageKeys } from './../models/storage/storage-keys';

export const AuthGuard = () => {
  const token = localStorage.getItem(StorageKeys.TOKEN);

  if (token) {
    return true;
  }

  const router = inject(Router);
  router.navigate(['/auth']);
  return false;
};
